(()=>{
const vis=e=>e.offsetParent!==null;
document.querySelectorAll('[data-cdg-box]').forEach(box=>{
  box.querySelectorAll('.cdg-win').forEach(win=>{
    const capa=win.parentElement,track=win.querySelector('.cdg-track'),cards=[...track.children],n=+win.dataset.cdgCar,p=+win.dataset.pitch,cw=+win.dataset.cw,x0=+win.dataset.x0;
    cards.forEach((c,i)=>{c.style.left=(i*p*100)+'%';});
    const grupos=[];for(let i=0;i<cards.length;i+=n)grupos.push([i,Math.min(i+n,cards.length)-1]);
    let g=0;
    const dots=capa.querySelector('.cdg-dots');
    if(dots){grupos.forEach((_,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('role','tab');b.setAttribute('aria-label','Produto '+(i+1));b.onclick=()=>ir(i);dots.appendChild(b);});}
    const prev=capa.querySelector('[data-cdg="prev"]'),next=capa.querySelector('[data-cdg="next"]');
    function ir(i){g=(i+grupos.length)%grupos.length;const[a,b]=grupos[g];let tx;
      if(n>1){const centro=(a*p+b*p+cw)/2;tx=.5-centro;}else{tx=x0-a*p;}
      track.style.transform='translateX('+(tx*100)+'%)';
      cards.forEach((c,i)=>{const on=i>=a&&i<=b;c.tabIndex=on?0:-1;c.setAttribute('aria-hidden',on?'false':'true');c.classList.toggle('is-off',!on);});
      if(dots)[...dots.children].forEach((d,i)=>d.setAttribute('aria-selected',i===g?'true':'false'));}
    track.style.width='100%';
    prev&&prev.addEventListener('click',()=>ir(g-1));next&&next.addEventListener('click',()=>ir(g+1));
    let sx=null;win.addEventListener('pointerdown',e=>{sx=e.clientX;});win.addEventListener('pointerup',e=>{if(sx===null)return;const d=e.clientX-sx;sx=null;if(Math.abs(d)>40)ir(g+(d<0?1:-1));});
    ir(0);
  });
});
document.querySelectorAll('[data-cdg-slider]').forEach(sl=>{
  const s=[...sl.querySelectorAll('.cdg-s')];let i=0;
  function ir(k){s[i].classList.remove('is-on');i=(k+s.length)%s.length;s[i].classList.add('is-on');}
  sl.querySelector('[data-cdg="prev"]').addEventListener('click',()=>ir(i-1));
  sl.querySelector('[data-cdg="next"]').addEventListener('click',()=>ir(i+1));
  let sx=null;sl.addEventListener('pointerdown',e=>{sx=e.clientX;});sl.addEventListener('pointerup',e=>{if(sx===null)return;const d=e.clientX-sx;sx=null;if(Math.abs(d)>40)ir(i+(d<0?1:-1));});
});
})();